import { Overlay } from '../elementOverlay';

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="block-media-big"]';

/**
 * Friendation component
 */
export const blockMediaBig = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    const handleImageZoom = () => {
      const trigger: HTMLButtonElement =
        component.querySelector('[data-overlay]');

      const dataElementOverlay: HTMLElement = component.querySelector(
        '[data-overlay-text]'
      );

      const dataElementClose: HTMLElement = component.querySelector(
        '[data-close-button-text]'
      );
      const overlayText = dataElementOverlay
        ? dataElementOverlay.dataset.overlayText
        : 'Overlay';
      const closeButtonText = dataElementClose
        ? dataElementClose.dataset.closeButtonText
        : 'Close';

      if (trigger) {
        const createOverlay = (e) => {
          e.preventDefault();

          const imageSrc = trigger.getAttribute('data-image');

          if (imageSrc) {
            const el: HTMLImageElement = document.createElement('img');
            el.src = imageSrc;
            const overlay = new Overlay();
            overlay.create('image', overlayText, el, closeButtonText);
          } else {
            return;
          }
        };

        trigger.addEventListener('click', createOverlay);

        trigger.removeAttribute('data-overlay');
      } else {
        return;
      }
    };

    if (component.querySelector('.image-zoom-enable')) {
      handleImageZoom();
    }
  });
};
